import { Component, OnInit } from '@angular/core';
import { AccService } from 'src/app/utils/services/acc.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/utils/services/app.service';

@Component({
  selector: 'app-login-system',
  templateUrl: './login-system.component.html',
  styleUrls: ['./login-system.component.scss'],
})
export class LoginSystemComponent implements OnInit {
  LoginCode: string;
  MaGV: string;
  constructor(
    public route: ActivatedRoute,
    private Acc: AccService,
    private toastr: ToastrService,
    private AppService: AppService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.LoginCode = params.Code;
      this.MaGV = params.Ma_gv;
      //console.log(params.Ma_gv)
    });
    var req = {
      TALoginCode: this.LoginCode,
      UserCategory: 1,
      ID_ph: 11,
    };

    this.Acc.LoginBySystemCode(req).subscribe((z) => {
      if (z.Status == 1) {
        localStorage.setItem('UserInfo', JSON.stringify(z));
        localStorage.setItem('SaveData', JSON.stringify( {
          "Ma_gv": this.MaGV
        }));
        this.AppService.login();
      } else {
        this.toastr.error(z.Message, 'Tác vụ thất bại');
        localStorage.setItem('SaveData', JSON.stringify( {
          "Ma_gv": ""
        }));
      }
    });
  }
}
